import React from "react" ;
import {Route, Switch} from "react-router-dom";
import MyCalendar from "root/Calendar/Calendar";
import {PATH_LETTERBOX_CALENDAR, PATH_LETTERBOX_ROOT, PATH_HOME_ROOT} from "root/Wieldy/routePaths";

import ScrollRails from "../../Common/Body/ScrollRails";
import LetterboxTab from "root/Wieldy/ApplicationModules/Letterbox/Body/LetterboxTab";
import LetterboxAppBodyHeader from "root/Wieldy/ApplicationModules/Letterbox/Body/LetterboxAppBodyHeader";

const LetterboxAppBody= (props) =>
{
    return (
        <div className="dt-module__container">

            <LetterboxAppBodyHeader />

            <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>

                <div className="dt-module__content-inner">
                    <div className="dt-module__list">
                        <Switch>
                            <Route path={PATH_LETTERBOX_CALENDAR} render={(props) => <MyCalendar {...props}/>}/>
                            <Route path={PATH_LETTERBOX_ROOT} render={(thisprops) => <LetterboxTab child_uid='all' {...thisprops}/>}/>
                            <Route path={PATH_HOME_ROOT} render={(thisprops) => <LetterboxTab child_uid='all' {...thisprops}/>}/>
                        </Switch>
                    </div>
                </div>

                <ScrollRails />

            </div>
        </div>
    );
}

export default LetterboxAppBody;
